import { RootState } from "../../Store";

export const selectCropsState = (state: RootState) => state.agriSolution.cropsState;
export const selectTemperatureState = (state: RootState) => state.agriSolution.temperatureState;

export const selectCustomizedState = (state: RootState) => state.agriSolution.customizedState;

export const selectFarmState = (state: RootState) => state.agriSolution.farmState;
export const selectYield = (state: RootState) => state.agriSolution.yield;
export const selectDisplayUpdateButton = (state: RootState) => state.agriSolution.customizedState.displayUpdateButton;

export const selectReleaseGraphState = (state: RootState) => state.agriSolution.releaseGraphState;

export const selectRawMaterialBank = (state: RootState) => state.agriSolution.rawMaterialBank;

export const selectShowMobileMap = (state: RootState) => state.agriSolution.showMobileMap;

export const selectDisplayReleaseGraphType = (state: RootState) => state.agriSolution.releaseGraphState.displayReleaseGraphType;
export const selectRecommendedMaterialCode = (state: RootState) => state.agriSolution.recommendedSolutionMaterialCode;

export const selectShelfSolutionCurrentDayReleaseRemainValues = (state: RootState) =>
    state.agriSolution.releaseGraphState.shelfSolutionCurrentDayReleaseRemainValues;

export const selectCustomizedSolutionCurrentDayReleaseRemainValues = (state: RootState) =>
    state.agriSolution.releaseGraphState.customizedSolutionCurrentDayReleaseRemainValues;

export const selectSaveInProgress = (state: RootState) => state.agriSolution.saveInProgress;
export const selectRecommendedSolutionName = (state: RootState) => state.agriSolution.recommendedSolutionName;

export const selectItemId = (state: RootState) => state.agriSolution.itemId;

export const isCarbonBannerShown = (state: RootState) => state.agriSolution.carbonBannerShown === true;

export const selectItemName = (state: RootState) => state.agriSolution.itemName;

export const selectIsUserSave = (state: RootState) => state.agriSolution.isUserSave;

export const selectStepsAvailability = (state: RootState) => ({
    soilStateCanBeNavigated: state.agriSolution.soilStateCanBeNavigated,
    resultsStateCanBeNavigated: state.agriSolution.resultsStateCanBeNavigated,
    farmStateCanBeNavigated: state.agriSolution.farmStateCanBeNavigated,
    customizeStateCanBeNavigated: state.agriSolution.customizeStateCanBeNavigated,
});

export const selectSoilState = (state: RootState) => state.agriSolution.temperatureState;

export const selectResultState = (state: RootState) => state.agriSolution.resultsState;

export const selectLocationCountryCodeState = (state: RootState) => state.agriSolution.cropsState.selectedLocationCountryCode;

export const selectStepIndexPage = (state: RootState) => state.agriSolution.stepIndexPage;

export const selectIsAgriItem = (state: RootState) => state.agriSolution.isAgriItem;

export const selectRecommendedSolution = (state: RootState) => state.agriSolution.resultsState.recommendedSolution;
